import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import {ActionsBase, DispatchAll, IncludeResultCallbacks} from '@store/@types/alt';
import {List} from 'immutable';
import {Job, JobId, ModifyJobRequest} from '@store/@types/kpi';
import JobSource from '@store/job/JobSource';

interface AsyncActions {
  getJobsInAccount(): Promise<List<Job>>;
  createJob(data: ModifyJobRequest): Promise<Job>;
  updateJob(data: ModifyJobRequest, id: JobId): Promise<Job>;
  deleteJob(id: JobId): Promise<void>;
}

interface SyncActions {}

export interface JobActionsInterface extends IncludeResultCallbacks<AsyncActions>, SyncActions {}

class JobActions
  extends ActionsBase<AsyncActions, SyncActions>()
  implements DispatchAll<AsyncActions>
{
  constructor() {
    super();
    this.generateActions(
      ...generateAsyncActions<AsyncActions>(
        'getJobsInAccount',
        'createJob',
        'updateJob',
        'deleteJob'
      )
    );
  }

  getJobsInAccount() {
    return dispatch => {
      dispatch();
      return JobSource.getJobsInAccount().then(
        this.getJobsInAccountSuccess,
        this.getJobsInAccountError
      );
    };
  }

  createJob(data: ModifyJobRequest) {
    return dispatch => {
      dispatch(data);
      return JobSource.createJob(data).then(this.createJobSuccess, this.createJobError);
    };
  }

  updateJob(data: ModifyJobRequest, id: JobId) {
    return dispatch => {
      dispatch(id, data);
      return JobSource.updateJob(id, data).then(this.updateJobSuccess, this.updateJobError);
    };
  }

  deleteJob(id) {
    return dispatch => {
      dispatch(id);
      return JobSource.deleteJob(id).then(this.deleteJobSuccess, this.deleteJobError);
    };
  }
}

export default alt.createActions<AsyncActions, SyncActions>(JobActions);
